import { render, staticRenderFns } from "./HotCompany.vue?vue&type=template&id=93546f1a&scoped=true&"
import script from "./HotCompany.vue?vue&type=script&lang=js&"
export * from "./HotCompany.vue?vue&type=script&lang=js&"
import style0 from "./HotCompany.vue?vue&type=style&index=0&id=93546f1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93546f1a",
  null
  
)

export default component.exports